var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoPointGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "16px",
    viewBox: "0 0 12 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Kita",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Template---Betreuungsgrad---kk---tooltip",
    transform: "translate(-1348.000000, -1115.000000)",
    fill: "#cacbcb",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capacity-by-Kita",
    transform: "translate(304.000000, 856.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header",
    transform: "translate(0.000000, 234.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1050,25 C1053.312,25 1056,27.7747097 1056,31.1935484 C1056,34.6123871 1053.312,37.3870968 1050,37.3870968 C1046.688,37.3870968 1044,34.6123871 1044,31.1935484 C1044,27.7747097 1046.688,25 1050,25 Z M1049.25,35.0645161 L1050.75,35.0645161 L1050.75,30.4193548 L1049.25,30.4193548 L1049.25,35.0645161 Z M1049.25,28.8709677 L1050.75,28.8709677 L1050.75,27.3225806 L1049.25,27.3225806 L1049.25,28.8709677 Z",
    id: "Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoPointGray);
export default __webpack_public_path__ + "static/media/info-point-gray.86e24d125c91b77ee15aff9e763b57cf.svg";
export { ForwardRef as ReactComponent };